module.exports = __webpack_public_path__ + "img/stapled-matte.6c951a76.png";